import * as React from 'react';
export default function useControlledState(defaultStateValue, option) {
    var _a = option || {}, defaultValue = _a.defaultValue, value = _a.value, onChange = _a.onChange, postState = _a.postState;
    var _b = React.useState(function () {
        if (value !== undefined) {
            return value;
        }
        if (defaultValue !== undefined) {
            return typeof defaultValue === 'function'
                ? defaultValue()
                : defaultValue;
        }
        return typeof defaultStateValue === 'function'
            ? defaultStateValue()
            : defaultStateValue;
    }), innerValue = _b[0], setInnerValue = _b[1];
    var mergedValue = value !== undefined ? value : innerValue;
    if (postState) {
        mergedValue = postState(mergedValue);
    }
    // setState
    var onChangeRef = React.useRef(onChange);
    onChangeRef.current = onChange;
    var triggerChange = React.useCallback(function (newValue) {
        setInnerValue(newValue);
        if (mergedValue !== newValue && onChangeRef.current) {
            onChangeRef.current(newValue, mergedValue);
        }
    }, [mergedValue, onChangeRef]);
    // Effect of reset value to `undefined`
    var firstRenderRef = React.useRef(true);
    React.useEffect(function () {
        if (firstRenderRef.current) {
            firstRenderRef.current = false;
            return;
        }
        if (value === undefined) {
            setInnerValue(value);
        }
    }, [value]);
    return [mergedValue, triggerChange];
}
